import { Component, OnInit, AfterViewInit, ElementRef } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from "@angular/router";

import { WindowService } from "../services/window.service";
import {
    RoomConfigurationInterface,
    MainConfigurationInterface, ConfigurationLoader
} from "../services/configuration.loader";
import { ProductGroup, AlternativeSelectedEvent } from "../model/product.group";
import { Logger } from "../utils/logger";
import { ProductSelectedEvent, Product } from "../model/product";
import { SubProductSelectedEvent, SubProduct } from "../model/subproduct";
import { PageStatePersister } from "../utils/page_state";
import { EventsService } from "../services/events.service";
import { CONFIG } from "../config";

import { CanvasProducts } from '../canvas/canvas.component'
import { CanvasSubProducts } from '../canvas/canvas.component'

import { Base64 } from "../utils/base64";

import { TranslateService } from '@ngx-translate/core';
import { LocalTranslateService } from "../services/local_translate.service";

@Component({
    selector: 'constr',
    providers: [],
    templateUrl: './configurator.component.html'
})
export class ConfiguratorComponent implements OnInit, AfterViewInit {

    public title: any;
    public sidebarTitle: string;

    public productGroups: Array<ProductGroup> = [];
    public selectedProductGroup: ProductGroup = null;

    public selectedSubProducts: Array<ProductGroup> = [];

    public roomIndex = 0;
    public storeId = 1;

    public isAllShown = true;

    public total: number = 0;
    public selectedProduct: Product = null;
    public selectedSubProduct: SubProduct = null;
    public selectedProducts: Array<ProductGroup> = [];

    public config;

    public filtersNames = [];

    public setDefaultCategoryProductGroupHandler = null;
    public setDefaultCategorySubProductGroupHandler = null;

    public panelsShowState = {
        isTotalPriceShown: false,
        isProductDetailsShown: false,
        isSidebarShown: false,
        isPriceBageShown: true,
        isMarkersShown: true,
        pageLoaderShown: true,
        isEmailBoxShown: false,
        isLinkBoxShown: false,
        isShowMenuBtnShown: true,
        isFilterPanelShown: false
    };

    public productsFilters: Array<{ type: string, list: Array<any> }> = [];

    public prevPanelsShowState = {};

    public stateLink;

    public mainConfiguration: MainConfigurationInterface = {
        Client: "Norrlands Trä",
        MagentoUrl: "",
        LogoUrl: "",
        PageTitle: "Norrlands Configurator",
        StartScreen: {
            "Title": "Välj din miljö!",
            "Subtitle1": "Välkommen till vårt designverktyg för att inspireras!",
            "Subtitle2": "Börja med att välja din miljö för att sedan se hur den ser ut med olika paneler och golv.",
            "BackgroundImage": "img/intro-bg.jpg"
        },
        Email: {
            "Subject": "Norrlands Trä",
            "FromAddress": "noreply@norrlandstra.se",
            "Body": "Hej!\n\nKolla in min design hos"
        },
        PriceUnit: "Kr/m2",
        ShowPrice: false,
        ShowSumPrice: false,
        Room: []
    };
    public roomConfiguration: RoomConfigurationInterface = null;

    public canvasProducts: CanvasProducts = null;
    public canvasSubProducts: CanvasSubProducts = null;

    public stateStr: string = "";

    public pageTitle = "";

    public alternative?: { index: number, groupName: string } = null;

    public savedAlternatives: Array<any>;

    // public currentLanguage: string;


    constructor(
        public translate: TranslateService,
        public localTranslate: LocalTranslateService,
        public router: Router,
        public el: ElementRef,
        public route: ActivatedRoute,
        public location: Location,
        public winService: WindowService,
        public configuratorLoader: ConfigurationLoader,
        public logger: Logger,
        public eventBus: EventsService) {
        this.title = { value: 'Norrlands Configurator' };
        this.sidebarTitle = "Vaggpanel";
        this.logger.debug(this.route);

        this.route.params.subscribe((data: any) => {
            let index = data.room;
            let storeId = data.store;
            this.stateStr = typeof data.state !== 'undefined' ? data.state : null;

            if (typeof index !== 'undefined') {
                this.roomIndex = parseInt(index);
            }

            if (typeof storeId !== 'undefined') {
                this.storeId = parseInt(storeId);
            }

            // this.currentLanguage = typeof data.lang !== 'undefined' ? data.lang : null;
            // if (this.currentLanguage) {
            this.localTranslate.setCurrentLang(this.storeId);
            // }
        });

        this.config = CONFIG;
    }

    ngOnInit() {
        this.winService.scale();

        this.configuratorLoader.setStore(this.storeId);
        this.configuratorLoader.getConfiguration(this.roomIndex).subscribe((conf: { main: MainConfigurationInterface, room: RoomConfigurationInterface }) => {
            this.roomConfiguration = conf.room;
            this.mainConfiguration = conf.main;
            this.pageTitle = this.mainConfiguration.PageTitle;
            this.updatePageTitle(this.roomConfiguration.Title);

            this.configuratorLoader.loadProductsForRoom(conf.room).subscribe((productsGroups: Array<ProductGroup>) => {
                this.productGroups = productsGroups;

                // this.setDefaultCategoryProductGroupHandler = () => {
                //
                // };
                let def = null;
                this.productGroups.forEach((group: ProductGroup) => {
                    // this.logger.debug(group);
                    if (def === null && group.isDefault()) {
                        def = group;
                        return false;
                    }
                });
                if (def === null) {
                    def = this.productGroups[0];
                }
                this.selectedProductGroup = def;

                this.panelsShowState.pageLoaderShown = false;

                this.selectedProducts = [];
                this.selectedSubProducts = [];

                let statePersister = new PageStatePersister(this.stateStr, productsGroups);

                let res = statePersister.retrieveState();

                // console.log(res);

                if (res) {
                    this.savedAlternatives = [];
                    this.selectedProducts = res;
                    this.selectedSubProducts = res;

                    this.alternative = { index: this.selectedProductGroup.getAltNumber(), groupName: this.selectedProductGroup.getName() };

                    res.forEach(group => {
                        this.savedAlternatives.push({ index: group.getAltNumber(), groupName: group.getName() });
                    });
                } else {
                    if (res !== null) {
                        this.router.navigateByUrl("/");
                    } else {
                        productsGroups.forEach((g) => {
                            let newProductGroup;

                            const subProductDefaultChoice = (g.getSubProductDefaultChoice() != 0)
                                && g.getSubProductDefaultChoice() - 1
                                || g.getSubProductDefaultChoice();

                            if (g.getSubProducts()[subProductDefaultChoice] != undefined) {
                                newProductGroup = ProductGroup.clone(g, [g.getProducts()[0]], [g.getSubProducts()[subProductDefaultChoice]]);
                            } else {
                                newProductGroup = ProductGroup.clone(g, [g.getProducts()[0]], null);
                            }
                            this.selectedProducts.push(newProductGroup);
                            this.selectedSubProducts.push(newProductGroup);
                        });
                    }
                }

                this.selectedProducts.forEach((group) => {
                    group.getProducts()[0].isSelected = true;
                    if (group.getSubProducts()) {
                        group.getSubProducts()[0].isSelected = true;
                    }
                });

                this.updateCanvasProducts();
                this.updateCanvasSubProducts();
                this.calculateTotal();
                this.changeStateLink();
            });
        })
    }

    updatePageTitle(title) {
        let pageTitle;
        let roomTitle;

        this.translate.get([this.pageTitle, title]).subscribe((res: Object) => {
            pageTitle = res[this.pageTitle];
            roomTitle = res[title];

            window.document.title = pageTitle + " | " + roomTitle;
        });
    }



    public updateCanvasProducts() {
        if (!this.canvasProducts) {
            this.canvasProducts = [];

            let res = this.selectedProducts.slice();
            res.sort((a: ProductGroup, b: ProductGroup) => {
                if (a.getDepthValue() > b.getDepthValue()) {
                    return 1;
                } else if (a.getDepthValue() < b.getDepthValue()) {
                    return -1;
                } else {
                    return 0;
                }
            });
            this.canvasProducts = res;
        } else {
            this.selectedProducts.forEach((g) => {
                this.canvasProducts.forEach((cg) => {
                    if (g.getName() == cg.getName()) {
                        cg.replaceProduct(0, g.getProducts()[0]);
                    }
                });
            });
        }
    }

    public updateCanvasSubProducts() {
        if (!this.canvasSubProducts) {
            this.canvasSubProducts = [];
            let res = [];
            // this.logger.debug("selected groups: ", this.selectedSubProducts);
            res = this.selectedSubProducts.slice();
            res.sort((a: ProductGroup, b: ProductGroup) => {
                if (a.getSubProductDepthValue() > b.getSubProductDepthValue()) {
                    return 1;
                } else if (a.getSubProductDepthValue() < b.getSubProductDepthValue()) {
                    return -1;
                } else {
                    return 0;
                }
            });
            this.canvasSubProducts = res;
        } else {
            this.selectedSubProducts.forEach((g) => {
                if (g.getSubProducts() && g.getSubProducts().length > 0) {
                    this.canvasSubProducts.forEach((cg) => {
                        if (g.getName() == cg.getName()) {
                            cg.replaceSubProduct(0, g.getSubProducts()[0]);
                        }
                    });
                }
            });
        }
    }

    toPixelSize(pos, dir = "x", inverse = false) {
        return ((inverse ? -1 : 1) * pos) + "px";
    }

    ngAfterViewInit(): any {

    }


    showSidebar(group: ProductGroup) {
        //this.setDefaultCategoryProductGroupHandler = null;
        this.selectedProductGroup = group;

        this.setDefaultCategorySubProductGroupHandler = null;

        this.panelsShowState.isSidebarShown = true;
        this.panelsShowState.isProductDetailsShown = false;
        this.panelsShowState.isFilterPanelShown = false;
        this.panelsShowState.isShowMenuBtnShown = !this.panelsShowState.isSidebarShown;
    }

    hideSidebar() {
        this.panelsShowState.isSidebarShown = false;
        // window.setTimeout(()=> {
        this.panelsShowState.isShowMenuBtnShown = !this.panelsShowState.isSidebarShown;
        // }, 300);
    }

    toggleSidebar() {
        this.panelsShowState.isSidebarShown = !this.panelsShowState.isSidebarShown;
        // window.setTimeout(()=> {
        this.panelsShowState.isShowMenuBtnShown = !this.panelsShowState.isSidebarShown;
        // }, 300);
        return false;
    }

    togglePriceTotal() {
        // window.setTimeout(()=> {
        this.panelsShowState.isTotalPriceShown = !this.panelsShowState.isTotalPriceShown;
        //}, 300);
    }

    hideTotalPrice() {
        // window.setTimeout(()=> {
        this.panelsShowState.isTotalPriceShown = false;
        //}, 300);
    }

    onProductSelected(event?: ProductSelectedEvent) {
        let selected = null;
        let selectedIndex = 0;

        event.productGroup.getProducts().forEach((product) => {
            product.isSelected = false;
        });

        this.selectedProducts.forEach((group, i) => {
            if (group.getName() === event.productGroup.getName()) {
                event.product.isSelected = true;

                if (group.getSubProducts() != null) {
                    selected = ProductGroup.clone(event.productGroup, [event.product], [group.getSubProducts()[0]]);
                } else {
                    selected = ProductGroup.clone(event.productGroup, [event.product], null);
                }

                selected.setAltNumber(this.selectedProductGroup.getAltNumber());
                selectedIndex = i;
                return false;
            }
        });

        if (selected !== null) {
            this.selectedProducts[selectedIndex] = selected;
            this.updateCanvasProducts();
            this.calculateTotal();
            this.changeStateLink();
        }
    }

    onProductInfo(product?: Product) {
        //  window.setTimeout(()=> {
        this.hideFilterPanel();
        if (this.selectedProduct && this.selectedProduct.articleNumber.getValue() == product.articleNumber.getValue() && this.selectedProduct.id.getValue() == product.id.getValue()) {
            this.panelsShowState.isProductDetailsShown = !this.panelsShowState.isProductDetailsShown;
        } else {
            this.selectedProduct = product;
            this.panelsShowState.isProductDetailsShown = true;
        }
        // }, 300);
    }

    onSubProductSelected(event?: SubProductSelectedEvent) {
        let selected = null;
        let selectedIndex = 0;

        event.productGroup.getSubProducts().forEach((subProduct) => {
            subProduct.isSelected = false;
        });

        this.selectedSubProducts.forEach((group, i) => {
            if (group.getName() === event.productGroup.getName()) {
                this.selectedSubProduct = event.subProduct;
                event.subProduct.isSelected = true;
                selected = ProductGroup.clone(event.productGroup, [group.getProducts()[0]], [event.subProduct]);
                selected.setAltNumber(this.selectedProductGroup.getAltNumber());
                selectedIndex = i;

                return false;
            }
        });

        // this.selectedProductGroup.randomNumber = Math.random();

        /*
            this.selectedProductGroup.getSubProducts().forEach((subProduct) => {
                if (subProduct.id.getValue() == event.subProduct.id.getValue() && subProduct.articleNumber.getValue() == event.subProduct.articleNumber.getValue()) {
                    subProduct.isSelected = true;
                }
            });
        */

        if (selected !== null) {
            this.selectedSubProducts[selectedIndex] = selected;

            this.updateCanvasSubProducts();
            this.calculateTotal();
            this.changeStateLink(); // presist new state for URL when subproduct is selected
        }
    }

    onAlternativeSelected(event?: AlternativeSelectedEvent) {
        this.selectedProductGroup.setAltNumber(event.altNumber);
        this.alternative = { index: event.altNumber, groupName: event.productGroup.getName() };

        this.selectedProducts = this.selectedProducts.map(group => {
            if (group.getName() == this.selectedProductGroup.getName()) {
                group.setAltNumber(event.altNumber);
            }

            return group;
        });

        this.changeStateLink();
    }

    onFilterPanel() {
        this.hideProductDetails();
        this.panelsShowState.isFilterPanelShown = !this.panelsShowState.isFilterPanelShown;
    }

    public changeStateLink() {
        let persister = new PageStatePersister();
        let str = persister.persistState(this.selectedProducts, this.selectedSubProducts);
        this.stateLink = /*"http://" + window.location.hostname +*/ (window.location.hash.replace(/(\d+)\/(\d+)\/[\w%\+]+$/, "$1/$2") + "/" + str).replace(/(#)/, "");
        // alert(window.location.hash)
        this.location.replaceState(this.stateLink);
    }

    public calculateTotal() {
        let res = 0.00;
        this.selectedProducts.forEach((group: ProductGroup) => {
            let product: Product = group.getProducts()[0];
            if (product) {
                res += product.price.getValue();
            }
        });
        this.total = res;
        return res;
    }

    public toggleVisibilityAll() {
        this.isAllShown = !this.isAllShown;
        if (this.isAllShown) {
            for (let i in this.prevPanelsShowState) {
                if (this.prevPanelsShowState.hasOwnProperty(i)) {
                    this.panelsShowState[i] = this.prevPanelsShowState[i];
                }
            }
        } else {
            for (let i in this.panelsShowState) {
                if (this.panelsShowState.hasOwnProperty(i)) {
                    this.prevPanelsShowState[i] = this.panelsShowState[i];
                    this.panelsShowState[i] = false;

                }
            }
        }
    }

    public resetProducts() {
        let selected = [];
        this.selectedProducts.forEach((selectedGroup: ProductGroup) => {
            this.productGroups.forEach((group: ProductGroup) => {
                if (group.getName() == selectedGroup.getName()) {
                    if (group.getSubProducts().length > 0) {
                        selected.push(ProductGroup.clone(group, [group.getProducts()[0]], [group.getSubProducts()[0]]));
                    } else {
                        selected.push(ProductGroup.clone(group, [group.getProducts()[0]], null));
                    }
                    group.getProducts().forEach((p) => {
                        p.isSelected = false;
                    });

                    group.getSubProducts().forEach((p) => {
                        if (p) {
                            p.isSelected = false;
                        }
                    });
                    group.getProducts()[0].isSelected = true;
                    if (group.getSubProducts() && group.getSubProducts().length > 0 && group.getSubProducts()[0]) {
                        group.getSubProducts()[0].isSelected = true;
                    }

                    return false;
                }
            })
        });


        this.selectedProducts = selected;
        this.selectedSubProducts = selected;

        this.updateCanvasProducts();
        this.updateCanvasSubProducts();

        this.calculateTotal();
        this.changeStateLink();
    }

    hideProductDetails() {
        this.panelsShowState.isProductDetailsShown = false;
    }

    hideFilterPanel() {
        this.panelsShowState.isFilterPanelShown = false;
        // window.setTimeout(()=> {
        //
        // }, 300);
    }


    public showEmailBox() {
        this.panelsShowState.isEmailBoxShown = true;
    }

    public onEmailBoxHide() {
        this.panelsShowState.isEmailBoxShown = false;
    }

    public showLinkBox() {
        // this.panelsShowState.isLinkBoxShown = true;
        // let link = this.stateLink;
        // let title = this.mainConfiguration.Client + " Configurator";
        // if (window.sidebar && window.sidebar.addPanel) { // Mozilla Firefox Bookmark
        //     window.sidebar.addPanel(title, window.location.href, '');
        // } else if (window.external && ('AddFavorite' in window.external)) { // IE Favorite
        //     window.external.AddFavorite(window.location.href, title);
        // } else if (window.opera && window.print) { // Opera Hotlist
        //     this.title = title;
        //     return true;
        // } else { // webkit - safari/chrome
        //     alert('Press ' + (navigator.userAgent.toLowerCase().indexOf('mac') != -1 ? 'Command/Cmd' : 'CTRL') + ' + D to bookmark this page.');
        // }
        let request = {
            // lang: this.currentLanguage,
            store: this.storeId,
            room: this.roomIndex - 1,
            products: []
        };
        this.selectedProducts.forEach((product, index) => {
            request.products.push({
                group: product.getName(),
                articleNumber: product.getProducts()[0].articleNumber.getValue(),
                subProductArticleNumber: this.selectedSubProducts[index].getSubProducts() ? this.selectedSubProducts[index].getSubProducts()[0].articleNumber.getValue() : ""
            });
        });

        // console.log();

        window.open(CONFIG.apiPath + "api/pdf.php?p=" + Base64.encode(JSON.stringify(request)), "_blank");

    }

    public onLinkBoxHide() {
        this.panelsShowState.isLinkBoxShown = false;
    }

    public resetFilters() {
        let rensaFilter = document.getElementById('rensa-filter');

        if (rensaFilter) {
            rensaFilter.click();
        }
    }

    onFiltersChanged(filters) {
        this.productsFilters = filters.slice();
    }
}



// WEBPACK FOOTER //
// ./src/app/configurator/configurator.component.ts